(function () {
  var scentMap = {};

  function buildScentMap() {
    scentMap = {};
    document.querySelectorAll('script.vyb-fragrance-data').forEach(function (el) {
      var scent = el.dataset.scent;
      try {
        var desc = JSON.parse(el.textContent);
        if (scent && desc) scentMap[scent.toLowerCase().trim()] = desc;
      } catch (e) {}
    });
  }

  function applyTooltips() {
    document.querySelectorAll('.vyb-pill-wrap').forEach(function (wrap) {
      var label = wrap.querySelector('.vyb-pill');
      var tooltip = wrap.querySelector('.vyb-pill__tooltip');
      if (!label || !tooltip) return;
      var scentKey = (label.dataset.vybScent || '').toLowerCase().trim();
      var desc = scentMap[scentKey];
      if (!desc) return;
      tooltip.textContent = desc;
    });
  }

  function init() {
    buildScentMap();
    applyTooltips();
  }

  // Re-apply after every click on a pill with a safe delay
  document.addEventListener('click', function (e) {
    if (e.target.closest('.vyb-pill-wrap')) {
      setTimeout(applyTooltips, 200);
      setTimeout(applyTooltips, 500);
    }
  });

  // Mobile close
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.vyb-pill-wrap')) {
      document.querySelectorAll('.vyb-pill-wrap.vyb-tooltip-open').forEach(function (w) {
        w.classList.remove('vyb-tooltip-open');
      });
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();